import { render, staticRenderFns } from "./CmsRegistTalk.vue?vue&type=template&id=2d419e24&scoped=true&"
import script from "./CmsRegistTalk.vue?vue&type=script&lang=js&"
export * from "./CmsRegistTalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d419e24",
  null
  
)

export default component.exports